var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavAdvertisingProducts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.25 4a.75.75 0 0 0-.75.75v10.5a.75.75 0 0 0 1.5 0V4.75A.75.75 0 0 0 3.25 4m8.644 0a.75.75 0 0 0-.75.75v10.5a.75.75 0 0 0 1.5 0V4.75a.75.75 0 0 0-.75-.75m-6.038.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1-.75-.75zM15.25 4a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75h1.5a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-.75-.75z"
})));
SvgNavAdvertisingProducts.displayName = "SvgNavAdvertisingProducts";
export { SvgNavAdvertisingProducts as ReactComponent };
export default SvgNavAdvertisingProducts;